import { createSlice } from "@reduxjs/toolkit";
import predictFractureApi from "@custom/rtk-apis/aiServices/predictFracture";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const predictFractureSlice = createSlice({
  name: "predictFractureSlice",
  initialState,
  reducers: {revertStatus (state:any) { state.status = ""; }},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(predictFractureApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(predictFractureApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(predictFractureApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default predictFractureSlice.reducer;
export const { revertStatus } = predictFractureSlice.actions;
